import { render, staticRenderFns } from "./SuggestionDefinition.vue?vue&type=template&id=11f29b49&"
import script from "./SuggestionDefinition.vue?vue&type=script&lang=js&"
export * from "./SuggestionDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports